export const parseAgeLimit = (value) => {
  const text = String(value || "").trim();
  if (!text || /all\s*ages/i.test(text)) return { from: "", to: "" };

  const numbers = text.match(/\d{1,3}/g) || [];
  return {
    from: numbers[0] || "",
    to: numbers[1] || "",
  };
};

export const formatAgeLimit = (from, to) => {
  const start = String(from || "").trim();
  const end = String(to || "").trim();
  if (!start && !end) return "";
  if (start && end) return `${start} - ${end} years`;
  if (start) return `${start}+ years`;
  return `0 - ${end} years`;
};
